import { render, staticRenderFns } from "./RegisterWorkerWithTokenView.vue?vue&type=template&id=231b5d90&"
import script from "./RegisterWorkerWithTokenView.vue?vue&type=script&lang=js&"
export * from "./RegisterWorkerWithTokenView.vue?vue&type=script&lang=js&"
import style0 from "./RegisterWorkerWithTokenView.vue?vue&type=style&index=0&id=231b5d90&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports